export function DismissButton({ onDismiss }: { onDismiss: () => void }) {
  return (
    <button class="payment-alert-dismiss" aria-label="Dismiss" onClick={onDismiss}>
      <span aria-hidden="true">✕</span>
    </button>
  );
}
